import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import type { CmsComponent } from "./CmsComponentsApi";
import DictionaryAccordion from "./DictionaryAccordion";
import EditCmsComponent from "./EditCmsComponentDialog";
import { useNewSeasonComponent } from "./useCmsComponent";

interface ComponentRowProps {
  readonly componentId: string;
  readonly component: CmsComponent | undefined;
  readonly onUpdate: (component: CmsComponent) => Promise<void>;
}

const ComponentRow: FC<ComponentRowProps> = ({ componentId, component, onUpdate }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <TableRow data-testid="region-row">
      <TableCell>{component?.title}</TableCell>
      <TableCell>{component?.description}</TableCell>
      <TableCell>{component?.buttonLabel}</TableCell>
      <TableCell>
        <Stack direction="row" spacing={2}>
          <IconButton size="small" aria-label="Edytuj treść" onClick={() => setDialogOpen(true)}>
            <EditIcon />
          </IconButton>
        </Stack>
        {dialogOpen && (
          <EditCmsComponent
            open={dialogOpen}
            componentId={componentId}
            component={component}
            onSave={onUpdate}
            onClose={() => setDialogOpen(false)}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

const AdditionalContent = () => {
  const { component, isLoading, updateComponent } = useNewSeasonComponent();
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  return (
    <DictionaryAccordion title="Treści dodatkowe" isLoading={isLoading}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "flex-end",
          padding: 1,
        }}
      ></Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nazwa</TableCell>
            <TableCell>Opis</TableCell>
            <TableCell>Etykieta przycisku</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          <ComponentRow
            key={"new-season"}
            componentId={"new-season"}
            component={component}
            onUpdate={async (updatedComponent) => {
              await updateComponent(updatedComponent);
            }}
          />
        </TableBody>
      </Table>
      {addDialogOpen && (
        <EditCmsComponent
          open={addDialogOpen}
          componentId={"new-season"}
          component={component}
          onSave={async (updatedComponent) => {
            await updateComponent(updatedComponent);
          }}
          onClose={() => setAddDialogOpen(false)}
        />
      )}
    </DictionaryAccordion>
  );
};

export default AdditionalContent;
